import React from 'react';
import { Shield, FileText, Database, Home, Plane } from 'lucide-react';
import InfoRow from './InfoRow';
import PillList from './PillList';

const dash = '–';

const ListingBack = ({ profile = {}, isCertified = false }) => {
  const requiredCaseTypes = (profile.clinicalExpectations?.requiredCaseTypes?.length
    ? profile.clinicalExpectations.requiredCaseTypes
    : [dash]);
  const emrSystem = profile.clinicalExpectations?.emrSystem ?? dash;
  const website = profile.website || dash;
  
  // Perks information moved from front to back
  const includesHousing = profile.includesHousing || profile.compensation?.includesHousing;
  const includesTravel = profile.includesTravel || profile.compensation?.includesTravel;
  const malpracticeCovered = profile.malpracticeCovered || profile.compensation?.malpracticeCovered;

  return (
    <div className="card-face-content listing-gradient-bg" role="region" aria-label="Listing Back">
      <div className="card-header">
        {isCertified && (
          <div className="cert-badge">
            <Shield size={18} className="cert-icon" />
          </div>
        )}
      </div>

      {/* Perks now on the back */}
      <InfoRow Icon={Home}>
        <PillList
          items={[includesHousing ? 'Housing' : 'No Housing']}
          getTooltip={() => 'Housing provided'}
          idPrefix="housing"
        />
      </InfoRow>
      
      <InfoRow Icon={Plane}>
        <PillList
          items={[includesTravel ? 'Travel' : 'No Travel']}
          getTooltip={() => 'Travel provided'}
          idPrefix="travel"
        />
      </InfoRow>
      
      <InfoRow Icon={Shield}>
        <PillList
          items={[malpracticeCovered ? 'Malpractice' : 'No Malpractice']}
          getTooltip={() => 'Malpractice insurance provided'}
          idPrefix="malpractice"
        />
      </InfoRow>

      <InfoRow Icon={FileText}>
        <PillList
          items={requiredCaseTypes}
          getTooltip={() => 'Required clinical case types'}
          idPrefix="case-type"
        />
      </InfoRow>

      <InfoRow Icon={Database}>
        <PillList
          items={[emrSystem]}
          getTooltip={() => 'EMR system used at this facility'}
          idPrefix="emr"
        />
      </InfoRow>

      {website !== dash && (
        <div className="website-container">
          <a href={website} target="_blank" rel="noopener noreferrer" className="website-link">
            Visit Facility Website
          </a>
        </div>
      )}
    </div>
  );
};

export default ListingBack;
